'use client';

import { ConfigurationFooter } from "@/types/configuration"
import Image from "next/image"

interface Props {
    configurationFooter: ConfigurationFooter
}

const Footer: React.FC<Props> = (props: Props) => {

    const renderLogos = () => {
        return props.configurationFooter.logos.map((logo, i) => {
            let className = "h-full flex items-center";
            if (i == 0) {
                className += " justify-center";
            } else {
                className += "  pl-5 lg:pl-10 border-l border-white";
            }
            return (
                <div className={className} key={`footer_logo_${i}`}>
                    <Image src={logo.src} alt={logo.alt} height={32} />
                </div>
            );
        })
    }

    const renderMessageCustomer = () => {
        if (props.configurationFooter.messageCustomer) {
            return props.configurationFooter.messageCustomer;
        }
        return null;
    }


    return (
        <div className="px-5 lg:px-40 py-20 lg:py-40 bg-blueDark text-white">
            <div className="flex h-full items-center space-x-5 lg:space-x-10 mb-5">
                {renderLogos()}
            </div>

            {renderMessageCustomer()}

            <div className='smallerText mb-3 mt-10'>
                Habacus srl - Sede legale: Via Cappuccio, 14, 20123 Milano (MI), Italia. C.F. e numero di iscrizione presso il Registro delle Imprese di Milano Monza Brianza Lodi 04906910262
            </div>
            <div className='smallerText'>
                Habacus srl &copy; 2025
            </div>
        </div >
    )
}

export default Footer;